import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CreateByMassiveExcel2Request {
  excelFile: File;
  portfolioId?: string;
  processManagerId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MassiveServices2Service {
  private readonly API_URL = `${environment.apiUrl}/es/Appraisals/CreateByMassiveExcel2`;

  constructor(private http: HttpClient) {}

  createByMassiveExcel2(request: CreateByMassiveExcel2Request): Observable<any> {
    const formData = new FormData();
    formData.append('excelFile', request.excelFile, request.excelFile.name);
    if (request.portfolioId) {
      formData.append('portfolioId', request.portfolioId);
    }
    if (request.processManagerId) {
      formData.append('processManagerId', request.processManagerId);
    }

    return this.http.post(this.API_URL, formData);
  }
}
